module.exports = __webpack_public_path__ + "img/04-iPhone.f6cc3509.png";